// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","4705":"dc112a36"}[chunkId] || chunkId) + "." + {"296":"f130ac7bbc1b3fd8","780":"c78f711b57c943e2","4357":"82f3c2d989700022","4705":"e6e96a1703e27d53","6837":"889b6d67fc3bddf7","7049":"626be413495364f2","7882":"597a9ed89cd1be0d","9260":"845c60e0bc97e8c5"}[chunkId] + ".js";
};